import styled from 'styled-components';

import { productCardTagStyle } from '~/src/common/components/GridCard/layout';
import type colors from '~/src/common/themes/main/colors';

export const TagsContainer = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 1;
  top: 8px;
  left: 8px;
  max-width: 78%;
  gap: 4px;

  & > div:first-child:not(:only-child) {
    flex-shrink: 0;
  }
`;

export const Tag = styled.div<{
  $backgroundColor: keyof typeof colors;
  $color: keyof typeof colors;
}>`
  ${productCardTagStyle};

  background-color: ${({ theme, $backgroundColor }) => theme.palette.common[$backgroundColor]};
  color: ${({ theme, $color }) => theme.palette.common[$color]};

  &::first-letter {
    text-transform: uppercase;
  }
`;

export const PromoTag = styled(Tag)`
  ${productCardTagStyle};

  &::first-letter {
    text-transform: uppercase;
  }
`;
